



























































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { InfiniteScroll } from "element-ui";
import {
  addEquipment,
  getlist,
  updateinfo,
  getdatainfo,
  getalldatalist,
  uploadfile,
  getequiptypelist,
  downloadFile,
} from "@/api/equipmanage";
import Pagination from "@/components/Pagination/index.vue";
import { drawEchart } from "./../../publicjs/echarts";
import moment from "moment";
Vue.use(InfiniteScroll);
@Component({
  name: "guideManage",
  components: { Pagination },
})
export default class extends Vue {
  [x: string]: any;
  // [x: string]: any;
  mounted() {
    this.getList(this.listQuery);
    this.getalllist();
    this.getsession();
  }

  public disabled() {
    return this.loading || this.noMore;
  }
  private currtentpage = 1;
  private total: number = 0;
  private formObj = {
    dialogVisible: false,
    diaupload: false,
  };
  // private options = [
  //   {
  //     key: "启用",
  //     value: 1,
  //   },
  //   {
  //     key: "禁用",
  //     value: 0,
  //   },
  // ];
  private tableData = [];
  private showspan = [];
  private multipleSelection = []; //表格多选存放的数组
  private currentPage: number = 1;
  private value: boolean = true;
  private isloading = true;
  private loadingscroll = false;
  private uploadParms = {};
  private fileSizeIsSatisfy: any = [];
  private addParams: any = {
    equipname: "",
    equipstate: "",
    equiptypeid: "",
    orginizeid: "",
    // traintime: "",
  };
  private options: any = [];
  private equipoptinons: any = [
    {
      key: "新品",
      value: 0,
    },
    {
      key: "正常",
      value: 1,
    },
    {
      key: "堪用",
      value: 2,
    },
    {
      key: "待修",
      value: 3,
    },
    {
      key: "在修",
      value: 4,
    },
    {
      key: "报废",
      value: 5,
    },
  ];
  private editparms: any = {
    equipname: "",
    equipstate: "",
    equiptypeid: "",
    // traintime: "",
    orginizeid: "",
    id: "",
    isdelete: 1,
  };
  private listQuery = {
    equipname: "",
    organid: "",
    page: 1,
    limit: 10,
  };
  // 表单校验规则
  private rules = {
    equipname: [
      { required: true, message: "请输入器材编号", trigger: "blur" },
      // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
    ],
    equiptypeid: [
      { required: true, message: "请选择器材类型", trigger: "change" },
      // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
    ],
    equipstate: [
      { required: true, message: "请选择器材状态", trigger: "change" },
    ],
    // traintime: [
    //   { required: true, message: "请选择器材使用起始时间", trigger: "change" },
    // ],
  };

  // 获取列表
  private async getList(params: any) {
    await getlist(params).then((res) => {
      if (res.code === 200) {
        this.isloading = false;
        // res.data.items.forEach((item: any) => {
        //   item.isuse = item.isuse == 1 ? true : false;
        // });
        this.tableData = res.data.itemBeanList;
        this.total = res.data.total;
        this.listLoading = false;
      }
    });
  }
  // private async getequipTypeList() {
  //   const param = {
  //     page: -1,
  //   };
  //   await getequiptypelist(param).then((res) => {
  //     if (res.code === 200) {
  //       // 渲染echarts
  //     }
  //   });
  // }
  private async getalllist() {
    const param: any = {
      page: -1,
      name: "",
      limit: "",
    };
    await getequiptypelist(param).then((res) => {
      if (res.code === 200) {
        this.isloading = false;
        let xdata: any = [];
        let ydata: any = [];
        res.data.items.forEach((item: any) => {
          this.options.push({
            key: item.name,
            value: item.id,
          });
          xdata.push(item.name);
          ydata.push(item.deviceCount);
        });
        drawEchart(
          this.$refs.echartsref,
          xdata,
          ydata,
          "器材类型统计",
          "数量",
          "器材类型"
        );
      }
    });
  }

  // private async changeSwitch(parms: any) {
  //   const usestate = parms.isuse === true ? 1 : 0;
  //   const param = {
  //     id: parms.id,
  //   };
  //   await getinfo(param).then(async (res) => {
  //     if (res.code === 200) {
  //       this.editparms = res.data;
  //       this.editparms.isuse = usestate;
  //       this.editparms.isdelete = 1;
  //       await editForm(this.editparms).then((res: any) => {
  //         if (res.code === 200) {
  //           this.$message({
  //             message: "状态更改成功",
  //             type: "success",
  //           });
  //           this.editparms = {};
  //         } else {
  //           this.$message({
  //             message: "状态更改失败",
  //             type: "warning",
  //           });
  //         }
  //       });
  //     }
  //   });
  // }
  private getsession() {
    let parm = sessionStorage.getItem("json");
    let parma: any = null;
    if (parm != null) {
      parma = JSON.parse(parm);
    }
    parma.orgnizeid = parma.orgnizeid.split(",").splice(0, 3).join(",");
    this.addParams.orginizeid = parma.orgnizeid;
    this.listQuery.organid = parma.orgnizeid;
  }
  private async deletedata(params: any) {
    const remove_parm: any = {
      equipname: params.equipname,
      equipstate: params.equipstate,
      // traintime: params.traintime,
      equiptypeid: params.equiptypeid,
      id: params.id,
      isdelete: 0,
      orginizeid: this.listQuery.organid,
    };

    this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(async () => {
      await updateinfo(remove_parm).then((res: any) => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getList(this.listQuery);
        } else {
          this.$message({
            message: "删除失败",
            type: "warning",
          });
        }
      });
    });
  }
  private onSubmit() {
    this.getList(this.listQuery);
  }
  private clearSearch() {
    this.listQuery.equipname = "";
    this.getList(this.listQuery);
  }
  private onCreatItem() {
    this.formObj.dialogVisible = true;
    this.$nextTick(() => {
      (this.$refs.addParams as any).resetFields();
      this.addParams = {
        equipname: "",
        equipstate: "",
        equiptypeid: "",
        orginizeid: "",
        // traintime: "",
      };
      this.getsession();
    });
  }
  private uploadfile() {
    this.formObj.diaupload = true;
    this.fileSizeIsSatisfy = [];
  }
  private async explodExcel() {
    let parm = sessionStorage.getItem("json");
    let parma: any = null;
    if (parm != null) {
      parma = JSON.parse(parm);
    }
    let organid = parma.orgnizeid;
    const httpurl =
      "http://192.168.4.10:8081/tellyes/devices/download?organid=" +
      organid +
      "";
    const savea = document.createElement("a");
    savea.download = "器材表";
    savea.href = httpurl;
    savea.click();
  }
  private handleSelectionChange(val: any) {
    this.multipleSelection = val;
  }
  private async handlefile() {
    const formdata = new FormData();
    formdata.append("orginizeid", this.addParams.orginizeid);
    formdata.append("file", this.fileSizeIsSatisfy[0]);
    await uploadfile(formdata).then((res) => {
      if (res.code === 200) {
        this.formObj.diaupload = false;
        this.getList(this.listQuery);
        this.fileSizeIsSatisfy = [];
        this.$message.success("器材表上传成功");
      } else if (res.code === 201) {
        this.$message.warning("器材编号不能相同，请检查表格内容重新上传");
      }
    });
  }
  private async editItem(params: any) {
    const parm = { id: params };
    await getdatainfo(parm).then((res: any) => {
      if (res.code === 200) {
        this.isloading = false;
        this.addParams = res.data;
      }
    });
    this.formObj.dialogVisible = true;
  }

  private handleClose(done: any) {
    this.formObj.dialogVisible = false;
    this.formObj.diaupload = false;
    this.addParams = {
      equipname: "",
      equipstate: "",
      // traintime: "",
      equiptypeid: "",
      orginizeid: "",
    };
  }

  private async subMitData() {
    const form = this.$refs.addParams as any;
    form.validate(async (valid: boolean) => {
      if (valid) {
        if (this.addParams.id) {
          // this.editparms.isdelete = 1;
          this.editparms = {
            equipname: this.addParams.equipname,
            equipstate: this.addParams.equipstate,
            // traintime: this.addParams.traintime,
            equiptypeid: this.addParams.equiptypeid,
            id: this.addParams.id,
            isdelete: 1,
            orginizeid: this.addParams.orginizeid,
          };
          await updateinfo(this.editparms).then((res) => {
            if (res.code === 200) {
              this.formObj.dialogVisible = false;
              form.resetFields();
              this.$message.success("修改成功");
              this.getList(this.listQuery);
              this.addParams = {
                name: "",
                description: "",
                isuse: "",
              };
              this.editparms = {
                name: "",
                description: "",
                isuse: "",
                isdelete: 1,
                id: "",
              };
            }
          });
        } else {
          // const begintime = moment(this.addParams.traintime[0]).format(
          //   "YYYY-MM-DD HH:mm:ss"
          // );
          // const endtime = moment(this.addParams.traintime[1]).format(
          //   "YYYY-MM-DD HH:mm:ss"
          // );
          // const addata_parm = {
          //   equipname: this.addParams.equipname,
          //   equipstate: this.addParams.equipstate,
          //   equiptypeid: this.addParams.equiptypeid,
          //   orginizeid: this.addParams.orginizeid,
          //   begintime: begintime,
          //   endtime: endtime,
          // };
          await addEquipment(this.addParams).then((res) => {
            if (res.code === 200) {
              this.formObj.dialogVisible = false;
              form.resetFields();
              this.$message.success("添加成功");
              this.getList(this.listQuery);
              this.addParams = {
                equipname: "",
                equipstate: "",
                equiptypeid: "",
                orginizeid: "",
                // traintime: "",
              };
            }
          });
        }
      } else {
        return false;
      }
    });
  }
  // 文件上传
  private handleExceed(file: any, fileList: any) {
    this.$message.warning(`当前限制上传 1 个文件`);
  }
  private fileOnChange(file: any) {
    let that: any = this;
    that.fileSizeIsSatisfy.push(file.raw);
  }
  private fileBeforeRemove(file: any, fileList: any) {
    this.fileSizeIsSatisfy = fileList;
  }
  // 分页
  private handleSizeChange(val: number) {
    this.listQuery.limit = val;
    this.getList(this.listQuery);
  }
  private handleCurrentChange(val: number) {
    this.listQuery.page = val;
    this.getList(this.listQuery);
  }
  private cellStyle({
    row,
    column,
    rowIndex,
    columnIndex,
  }: {
    row: any;
    column: any;
    rowIndex: any;
    columnIndex: any;
  }) {
    return "text-align:center";
  }

  private rowClass({ row, rowIndex }: { row: any; rowIndex: any }) {
    return "text-align:center";
  }
}
